import React, { useState, useContext } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
// * Helpers
import API from "../../services/api";
import MatrixContext from '../../assets/Constants/matrixContext';

import SelectBenefit from './scenarioBenefitModalViews/selectBenefit';
import LinkBenefitandGroups from './scenarioBenefitModalViews/linkBenefitandGroups';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { BiArrowFromRight } from "react-icons/bi";

// import BenefitDetails from './scenarioBenefitModalViews/benefitDetails';

import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';

import AuthContext from '../../context/Auth/AuthContext';

const ScenarioAddBenefit = () => {
    //* To can acess the parameters sent via history.push
    const location = useLocation();
    //* We use useHistory hook to redirect
    const history = useHistory();
    // Session context to get the current institution data
    const { get_currentInstitution, user } = useContext(AuthContext);

    // we call the hook to make translations
    const { t } = useTranslation('common');



    // * For change view
    const [view, setView] = useState('select_benefit')



    // * 
    const [selectedBenefit, setSelectedBenefit] = useState({});




    const changeView = (newView) => {
        setView(newView);

    }
    
    /**Triggered when user clicks "Go Back" button. Redirects to Scenario view*/
    const goBack = async () => {
        try {
            const response = await API.get(`/Scenario/UndoScenario?scenarioId=${location.state.detail.scenarioId}`);

            if (response.data.code !== 100) {
                Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                return;
            }else{
                history.push('/Scenarios');
            }
        } catch (error) {
            console.log(error);
            Notifications.notify(String(error), ERROR_NOTIFICATION);
        }
    }

    const handleAddBenefit = async (groupsList, detailsData) => {
        try {
            const groupsID = groupsList.map((item) => {
                return item.popGroupId
            });

            const data = {
                scenarioId: location.state.detail.scenarioId,
                benefitId: selectedBenefit.benefitId,
                IBAM: detailsData.ibam,
                IANTRANS: 0,
                IADM: 0,
                ICPMale: 0,
                ICPFemale: 0,
                ICHH: 0,
                ITHR_ABAM: detailsData.ithr_abam,
                groupsID: groupsID

            }
            const res = await API.post('/Scenario/InsertScenarioBenefit', data);

            if (res.data.code !== 100) {
                Notifications.notify(res.data.msg, ERROR_NOTIFICATION);
                return;
            }

            // APPLY CHANGES
            await API.get(`/Scenario/LockScenario?scenarioId=${location.state.detail.scenarioId}&userCode=system`);
            const response = await API.post(`Scheduler/addTask`, null, {
                params: {
                    ctxtcode: MatrixContext.SCENARIO,
                    scenarioid: location.state.detail.scenarioId,
                    opcode: 'ADB',
                    usrcode: user ? user.email : 'get_user_error',
                    customparams: JSON.stringify({ runblocks: ['load_data', 'gaps', 'init_elc'] })
                }
            });
            if (response.data.code !== 100) {
                Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                return;
            }
            Notifications.notify(t('scenarios.add_benefit.success_confirmation'), SUCCESS_NOTIFICATION);

            // Redirects to scenario list
            history.push('/Scenarios');

            Notifications.notify(t('scenarios.add_benefit.success_add'), SUCCESS_NOTIFICATION);
        } catch (error) {
            console.log(error);
            Notifications.notify(String(error), ERROR_NOTIFICATION);
        }
    }


    const handleAddAnotherBenefit = async (groupsList, detailsData) => {
        try {
            const groupsID = groupsList.map((item) => {
                return item.popGroupId
            });

            const data = {
                scenarioId: location.state.detail.scenarioId,
                benefitId: selectedBenefit.benefitId,
                IBAM: detailsData.ibam,
                IANTRANS: 0,
                IADM: 0,
                ICPMale: 0,
                ICPFemale: 0,
                ICHH: 0,
                ITHR_ABAM: detailsData.ithr_abam,
                groupsID: groupsID

            }
            const res = await API.post('/Scenario/InsertScenarioBenefit', data);

            if (res.data.code !== 100) {
                Notifications.notify(res.data.msg, ERROR_NOTIFICATION);
                return;
            }

            // Redirects to select benefits view
            changeView('select_benefit');

            Notifications.notify(t('scenarios.add_benefit.success_add'), SUCCESS_NOTIFICATION);
        } catch (error) {
            console.log(error);
            Notifications.notify(String(error), ERROR_NOTIFICATION);
        }

    }

    const switchView = () => {
        switch (view) {
            case 'select_benefit':
                return <SelectBenefit setSelectedBenefit={setSelectedBenefit} scenarioId={location.state.detail.scenarioId} changeView={changeView} goBack={goBack} />
            case 'link_benefit_andGroups':
                return <LinkBenefitandGroups selectedBenefit={selectedBenefit} setSelectedBenefit={setSelectedBenefit} scenarioId={location.state.detail.scenarioId} changeView={changeView} goBack={goBack} handleAddBenefit={handleAddBenefit} handleAddAnotherBenefit={handleAddAnotherBenefit} />
            // case 'benefitDetails':
            //     return <BenefitDetails selectedBenefit={selectedBenefit} linkGroups={linkGroups} setSelectedBenefit={setSelectedBenefit} setLinkGroups={setLinkGroups} scenarioId={location.state.detail.scenarioId} changeView={changeView} goBack={goBack} handleAddBenefit={handleAddBenefit} />
            default:
                return null;
        }
    }



    return (
        <>
            <div className="sub_menu">
                <div className="sub_menu_btns my-1">
                    <BiArrowFromRight />
                    <button className="ilo-btn wizard_goBack_btn pr-2" onClick={goBack}> {t('scenarios.add_benefit.goback')}</button> |
                    <span className="ilo-section-title pl-2">{location.state.detail.name}</span>

                </div>
            </div>
            <div className="container-fluid container_grid">
                <div className="row row_attrs justify-content-center">
                    <div className="col-md-8">
                        {switchView()}
                    </div>
                </div>
            </div>
        </>



    );
}

export default ScenarioAddBenefit;